import { FC, memo } from 'react'
import { Button, Flex } from '@chakra-ui/react'

import { CalendarFilter } from 'components'
import { ActivityFilter } from 'Activities/types'
import DataFilterFeedback from './components/DataFilterFeedback'
import { useCalendarFilterTemplate } from './contexts/CalendarFilterTemplateManager/Provider'

type Props = {
  filter: ActivityFilter
}

const CalendarFilterTemplateContent: FC<Props> = ({ filter }) => {
  const { onSubmitFilter, filterDate, setFilterDate } = useCalendarFilterTemplate()

  return (
    <>
      <DataFilterFeedback activityFilter={filter} mb={4} />

      <Flex direction="column" gap={4}>
        <CalendarFilter
          modalTitle="Selecione o filtro de data"
          defaultDates={filterDate}
          onSubmit={(dates) => {
            setFilterDate(dates)
            onSubmitFilter(dates)
          }}
          trigger={
            <Button minWidth="100%" id="open-data-filter-button" variant="outline" colorScheme="primary">
              Selecione o filtro de data
            </Button>
          }
        />
      </Flex>
    </>
  )
}

export default memo(CalendarFilterTemplateContent)
